/* Carpano Kart — controles de TOQUE (v0.1).
 * Joystick esquerdo = direção; botões direita: acelerar (gás), freio/ré, turbo.
 * Os botões viram "teclas virtuais" no SimpleCarController (pressiona as mesmas ações do teclado),
 * então nada do jogo original precisa saber que existe touch.
 * Detecta touch e aparece sozinho; em desktop fica escondido. */
import Experience from '../Experience.js'

export class TouchControls {
    constructor() {
        // NÃO instancia Experience aqui (import circular TDZ) — resolve lazy no apply()
        this.experience = null
        this.active = false
        this.build()
        this.listen()
    }

    build() {
        const wrap = document.createElement('div')
        wrap.id = 'kart-touch'
        wrap.style.cssText = 'position:fixed;inset:0;pointer-events:none;z-index:50;display:none;font-family:system-ui,sans-serif;user-select:none;-webkit-user-select:none;touch-action:none'
        wrap.innerHTML = `
            <div id="kt-joy" style="position:absolute;left:24px;bottom:24px;width:120px;height:120px;border-radius:50%;background:rgba(255,255,255,0.12);border:2px solid rgba(255,255,255,0.35);pointer-events:auto">
                <div id="kt-joy-knob" style="position:absolute;left:50%;top:50%;width:52px;height:52px;margin:-26px 0 0 -26px;border-radius:50%;background:rgba(255,255,255,0.55);box-shadow:0 2px 8px rgba(0,0,0,0.35)"></div>
            </div>
            <div id="kt-pedals" style="position:absolute;right:20px;bottom:24px;display:flex;gap:12px;align-items:flex-end;pointer-events:auto">
                <div class="kt-btn" data-k="brake" style="width:64px;height:64px;border-radius:50%;background:rgba(255,80,80,0.35);border:2px solid rgba(255,120,120,0.6);display:flex;align-items:center;justify-content:center;font-size:26px">🛑</div>
                <div class="kt-btn" data-k="turbo" style="width:64px;height:64px;border-radius:50%;background:rgba(80,180,255,0.35);border:2px solid rgba(120,200,255,0.6);display:flex;align-items:center;justify-content:center;font-size:26px">⚡</div>
                <div class="kt-btn" data-k="gas" style="width:84px;height:84px;border-radius:50%;background:rgba(80,255,120,0.35);border:2px solid rgba(140,255,170,0.6);display:flex;align-items:center;justify-content:center;font-size:34px">🔥</div>
            </div>
        `
        document.body.appendChild(wrap)
        this.wrap = wrap
        this.joy = wrap.querySelector('#kt-joy')
        this.knob = wrap.querySelector('#kt-joy-knob')
    }

    listen() {
        const first = () => { this.active = true; if (this.wrap) this.wrap.style.display = 'block'; }
        window.addEventListener('touchstart', first, { once: true, passive: true })

        // joystick → seta virtual
        let joyId = null
        const cx = () => this.joy.getBoundingClientRect()
        this.joy.addEventListener('pointerdown', (e) => { joyId = e.pointerId; this.joy.setPointerCapture(e.pointerId); moveKnob(e) })
        this.joy.addEventListener('pointermove', (e) => { if (e.pointerId === joyId) moveKnob(e) })
        const endJoy = (e) => { if (e.pointerId === joyId) { joyId = null; this.knob.style.transform = ''; this._setDir(0, 0) } }
        this.joy.addEventListener('pointerup', endJoy)
        this.joy.addEventListener('pointercancel', endJoy)

        const moveKnob = (e) => {
            const r = cx()
            const dx = (e.clientX - (r.left + r.width / 2)) / (r.width / 2)
            const dy = (e.clientY - (r.top + r.height / 2)) / (r.height / 2)
            const len = Math.hypot(dx, dy) || 1
            const nx = dx / Math.max(1, len), ny = dy / Math.max(1, len)
            this.knob.style.transform = `translate(${nx * 34}px, ${ny * 34}px)`
            this._setDir(nx, ny)
        }

        // botões → press/release das mesmas ações do teclado
        for (const btn of this.wrap.querySelectorAll('.kt-btn')) {
            const key = btn.dataset.k
            btn.addEventListener('pointerdown', (e) => { e.preventDefault(); btn.style.filter = 'brightness(1.6)'; this._press(key, true) })
            const up = (e) => { btn.style.filter = ''; this._press(key, false) }
            btn.addEventListener('pointerup', up)
            btn.addEventListener('pointerleave', up)
            btn.addEventListener('pointercancel', up)
        }
    }

    _setDir(nx, ny) {
        this.steer = nx
        this.throttle = -ny // joystick pra cima = acelerar
        this.apply()
    }

    _press(key, down) {
        this.keys = this.keys || {}
        this.keys[key] = down
        this.apply()
    }

    // espelha o input no SimpleCarController (forças), pelo mesmo caminho do teclado
    apply() {
        if (!this.experience) {
            try { this.experience = new Experience(); } catch (_) { return; }
        }
        const ctrl = this.experience.world?.simpleCar?.simpleCarController ||
                     this.experience.world?.simpleCarController
        if (!ctrl) return
        try {
            const steer = this.steer || 0
            const gas = this.keys?.gas || (this.throttle > 0.25)
            const brake = this.keys?.brake || (this.throttle < -0.25)
            const turbo = this.keys?.turbo || false
            if (typeof ctrl.setTouchInput === 'function') {
                ctrl.setTouchInput({ steer, gas, brake, turbo })
            }
        } catch (_) {}
    }
}
